<template>
  <nav class="navbar navbar-default navbar-fixed-top">
    <div class="container">
      <div class="navbar-header">
        <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <a class="navbar-brand" href="/">
          <img src="../assets/img/logo.png">
        </a>
      </div>
      <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
        <ul class="nav navbar-nav navbar-right">
          <router-link to="/" tag="li" active-class="active" exact><a>About us</a></router-link>
          <li>
            <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Conference Info <i class="fa fa-angle-down"></i></a>
            <ul class="dropdown-menu">
              <router-link to="/info_venue" tag="li" active-class="active" exact><a>About the Venue</a></router-link>
              <router-link to="/info_capetown" tag="li" active-class="active" exact><a>About Cape Town</a></router-link>
              <router-link to="/info_2017committee" tag="li" active-class="active" exact><a>AIDSImpact 2017 Committee</a></router-link>
              <router-link to="/info_delegateregistration" tag="li" active-class="active" exact><a>Delegate Registration</a></router-link>
            </ul>
          </li>
          <li>
            <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Previous Conferences <i class="fa fa-angle-down"></i></a>
            <ul class="dropdown-menu">
              <li><a href="2015/" target="_blank">2015 - Amsterdam, NL</a></li>
              <li><a href="2013/" target="_blank">2013 - Barcelona, Spain</a></li>
              <li><a href="2011/" target="_blank">2011 - Santa Fe, USA</a></li>
              <li><a href="2009/" target="_blank">2009 - Botswana</a></li>
              <li><a href="2007/" target="_blank">2007 - Marseille</a></li>
              <li><a href="2005/" target="_blank">2005 - Cape Town</a></li>
              <li><a href="2003/" target="_blank">2003 - Milan</a></li>
            </ul>
          </li>
          <transition appear name="fade" mode="out-in">
            <li v-if="this.authData" key="authorised">
              <a data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false">{{ this.currentUser.forename }} {{ this.currentUser.surname }} <strong v-if="this.currentUser.type == 'administrator'">(Admin) </strong><i class="fa fa-angle-down"></i></a>
              <ul class="dropdown-menu">
                <router-link to="/manageusers" v-if="(this.authData && this.currentUser.type == 'administrator')" tag="li" active-class="active" exact><a>Manage Users</a></router-link>
                <router-link to="/scregister" v-if="(this.authData && this.currentUser.type == 'administrator')" tag="li" active-class="active" exact><a>Preview Scientific Committee Registration</a></router-link>
                <li><a v-on:click="userLogout">Logout</a></li>
              </ul>
            </li>
            <li v-else key="unauthorised"><router-link to="/login">Login</router-link></li>
          </transition>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
// global variables
import Vuex from 'vuex';
import { mapState } from 'vuex'
import VuexFire from 'vuexfire';
import firebase from 'firebase';
import router from "../router"
// end global variables

// firebase initialisation
var db = firebase.database();
var firebaseAuth = firebase.auth();
// end firebase initialisation

export default {
  computed: {
    ...mapState({
      // map e.g. this.authData to store.state.authData
      authData: 'authData',
      contacts: 'contacts',
      currentUser: 'currentUser'
    })
  },
  created: function () {
    this.listenAuth();
  },
  data () {
    return {
      messageError: null,
      messageSuccess: null
    }
  },
  firebase: {
  },
  methods: {
    listenAuth: function () {
      var self = this;
      firebaseAuth.onAuthStateChanged(function (user) {
        if (user) { // if signed in
          self.$bindAsObject('currentUser', db.ref('users/' + user.uid));
        }
        else {
          if (self.currentUser) self.$unbind('currentUser');
        }
      });
    },
    userLogout: function (evt) { // signs out via firebase auth
      this.messageError = null;
      this.messageSuccess = null;
      if (firebase.auth().currentUser) {
        firebase.auth().signOut();
      }
      router.push("/");
    },
  },
}
</script>



/** WEBPACK FOOTER **
 ** headerblock.vue?1a0424e3
 **/